import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  DialogContent,
  Dialog,
  DialogActions,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  TextField,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { Close, DeleteOutline } from "@mui/icons-material";
import Axios from "../axios";
import { useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { Helmet } from "react-helmet";
import { useAuth } from "../auth/authContext";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {
  DndContext,
  closestCenter,
  useSensor,
  useSensors,
  PointerSensor,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import Grid from "@mui/material/Grid";

const Market = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [write, setWrite] = useState(false);

  const [isZhAuth, setIsZhAuth] = useState(false);
  const [zhToken, setZhToken] = useState("");
  const [channels, setChannels] = useState("");
  const [selectedChannel, setSelectedChannel] = useState("");
  const [markets, setMarkets] = useState();
  const [marketEdit, setMarketEdit] = useState(false);
  const [marketEditData, setMarketEditData] = useState();
  const [marketEditName, setMarketEditName] = useState();
  const [marketEditHotels, setMarketEditHotels] = useState([]);
  const [marketEditWeightage, setMarketEditWeightage] = useState();
  const [newHotelId, setNewHotelId] = useState("");

  const [opendel, setOpendel] = useState({ status: false, id: null });

  const sensors = useSensors(useSensor(PointerSensor));

  useEffect(() => {
    getChannels();
  }, [page, search]);

  const getChannels = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-channels", {
      zhAuth: zhToken,
    })
      .then((resp) => {
        setChannels(resp?.data?.data);
        setIsZhAuth(true);
        handleClose();
      })
      .catch((err) => {
        setIsZhAuth(false);
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  const handleChange = (data) => {
    if (data.target.value && data.target.value !== "") {
      setSelectedChannel("" + data?.target?.value);
      Axios.post(process.env.REACT_APP_BACKEND + "get-markets", {
        channel: data?.target?.value,
        page: 0,
        searchChar: "",
      })
        .then((resp) => {
          setMarkets(resp.data.data);
          setWrite(true);
        })
        .catch((err) => {
          toast.error(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        });
    }
  };

  const addHotel = () => {
    if (newHotelId) {
      setMarketEditHotels([
        ...marketEditHotels,
        { id: newHotelId, name: "Unknown" },
      ]);
      setNewHotelId("");
    }
  };

  const addEditHotel = () => {
    const hotelsRaw = marketEditHotels.map((item) => item.id).join(",");

    if (
      !marketEditName ||
      marketEditName === undefined ||
      marketEditName === null ||
      !hotelsRaw ||
      hotelsRaw === undefined ||
      hotelsRaw === null ||
      !marketEditWeightage ||
      marketEditWeightage === undefined ||
      marketEditWeightage === null
    ) {
      toast.error("Name, Weightage and Hotels should not be empty.");
      return;
    }

    if (open) {
      Axios.post(process.env.REACT_APP_BACKEND + "add-markets", {
        hotels: hotelsRaw,
        weightage: marketEditWeightage,
        name: marketEditName,
        channel: selectedChannel,
      })
        .then((resp) => {
          setMarkets(resp.data.data);
        })
        .catch((err) => {
          toast.error(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        });
    } else {
      Axios.post(process.env.REACT_APP_BACKEND + "update-markets", {
        zhId: marketEditData?.zhId,
        hotels: hotelsRaw,
        weightage: marketEditWeightage,
        name: marketEditName,
        channel: selectedChannel,
      })
        .then((resp) => {
          setMarkets(resp.data.data);
        })
        .catch((err) => {
          toast.error(
            err &&
              err.response &&
              err.response.data &&
              err.response.data.message
          );
        });
    }
    handleClose();
  };

  const handleHotelDelete = (hotelId) => {
    const filtered = marketEditHotels.filter((hotel) => hotel.id !== hotelId);
    setMarketEditHotels(filtered);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = marketEditHotels.findIndex((h) => h.id === active.id);
    const newIndex = marketEditHotels.findIndex((h) => h.id === over.id);

    const reordered = arrayMove(marketEditHotels, oldIndex, newIndex);
    setMarketEditHotels(reordered);

    console.log("New Priority:", reordered.map((h) => h.id).join(","));
  };

  const SortableRow = ({ hotel, index, onDelete }) => {
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id: hotel.id });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0.6 : 1,
      backgroundColor: isDragging ? "#f5f5f5" : "inherit",
    };

    return (
      <TableRow ref={setNodeRef} style={style} hover>
        <TableCell width="60px" align="center">
          <span
            {...attributes}
            {...listeners}
            style={{ cursor: "grab", display: "inline-flex" }}
          >
            <DragIndicatorIcon style={{ color: "#888" }} />
          </span>
        </TableCell>
        <TableCell>{index + 1}</TableCell>
        <TableCell>{hotel.id}</TableCell>
        <TableCell>{hotel.name}</TableCell>
        <TableCell>
          <IconButton color="error" onClick={(e) => onDelete(hotel.id)}>
            <DeleteOutline />
          </IconButton>
        </TableCell>
      </TableRow>
    );
  };

  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    search: true,
    viewColumns: false,
    rowsPerPageOptions: [],
    count: count,
    page,
    download: false,
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "zhId",
      label: "Zentrumhub Id",
      options: {
        filter: true,
        sort: false,
      },
    },

    write && {
      name: "",
      label: "Actions",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              {write ? (
                <>
                  <EditIcon
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setMarketEdit(true);
                      setMarketEditHotels(markets[dataIndex].hotels);
                      setMarketEditData(markets[dataIndex]);
                      setMarketEditName(markets[dataIndex].name);
                      setMarketEditWeightage(markets[dataIndex].weightage);
                    }}
                  />
                  <DeleteOutline
                    style={{
                      color: "red",
                      fontSize: "24px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setOpendel({
                        status: true,
                        id: markets[dataIndex]?.zhId,
                      })
                    }
                  />
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
    },
  ].filter(Boolean);
  const deleteAffiliate = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "delete-markets", {
      zhId: opendel?.id,
      channel: selectedChannel,
    })
      .then((resp) => {
        console.log(JSON.stringify(resp));
        setMarkets(resp.data.data);
        handleClose();
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleClose = () => {
    setMarketEdit(false);
    setOpen(false);
    setOpendel({
      status: false,
      id: null,
    });
    setMarketEditHotels([]);
    setMarketEditData();
    setMarketEditWeightage();
    setMarketEditName();
    setNewHotelId();
  };

  return (
    <>
      <Helmet>
        <title>Sevenly-Trip</title>
        <meta name="Trip List" content="Trip List for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-4">
        <h2>Market</h2>
      </div>
      {isZhAuth ? (
        <>
          {open || marketEdit ? (
            <Box display="flex" flexDirection="column" gap={2} mt={3}>
              <TextField
                label="Name"
                variant="outlined"
                required
                fullWidth
                className="my-2"
                placeholder="Name"
                name="name"
                onChange={(event) => setMarketEditName(event.target.value)}
                value={marketEditName}
              />
              <TextField
                label="Weightage"
                variant="outlined"
                required
                fullWidth
                className="my-2"
                placeholder="Weightage"
                name="weightage"
                type="number"
                onChange={(event) =>
                  setMarketEditWeightage(parseInt("" + event.target.value))
                }
                value={marketEditWeightage}
              />
              {open ? (
                <></>
              ) : (
                <TextField
                  label="Zentrumhub Id"
                  variant="outlined"
                  required
                  fullWidth
                  className="my-2"
                  placeholder="Zentrumhub Id"
                  name="Zentrumhub Id"
                  value={marketEditData?.zhId}
                />
              )}
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
                modifiers={[restrictToVerticalAxis]}
              >
                <SortableContext
                  items={marketEditHotels.map((h) => h.id)}
                  strategy={verticalListSortingStrategy}
                >
                  <TableContainer component={Paper} sx={{ mt: 2 }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell></TableCell>
                          <TableCell>Priority</TableCell>
                          <TableCell>Hotel Id</TableCell>
                          <TableCell>Hotel Name</TableCell>
                          <TableCell>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {marketEditHotels.map((hotel, index) => (
                          <SortableRow
                            key={hotel.id}
                            hotel={hotel}
                            index={index}
                            onDelete={handleHotelDelete}
                          />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box display="flex" gap={2} mt={2}>
                    <TextField
                      id="outlined-basic"
                      label="Hotel ID"
                      variant="outlined"
                      fullWidth
                      value={newHotelId}
                      onChange={(e) => setNewHotelId(e.target.value)}
                    />
                    <Button
                      className="w7 sevenly-btn text-white "
                      onClick={() => addHotel()}
                    >
                      <AddIcon />
                    </Button>
                  </Box>
                </SortableContext>
              </DndContext>
              <br />
              <Grid container>
                <Grid size="auto">
                  <Button
                    style={{ width: "100px", margin: "2px" }}
                    className="w7 sevenly-btn text-white "
                    onClick={() => {
                      setMarketEdit(false);
                      setOpen(false);
                      setOpendel({
                        status: false,
                        id: null,
                      });
                      setMarketEditHotels([]);
                      setMarketEditData();
                      setMarketEditWeightage();
                      setMarketEditName();
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid size="auto">
                  <Button
                    style={{ width: "100px", margin: "2px" }}
                    className="w7 sevenly-btn text-white "
                    onClick={() => {
                      addEditHotel();
                    }}
                  >
                    {open ? "Add" : "Edit"}
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <>
              <div className="d-flex justify-content-end mb-4">
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Channel</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedChannel}
                    label="Channel"
                    onChange={handleChange}
                  >
                    {channels.map((channel, index) => (
                      <MenuItem key={index} value={channel}>
                        {channel}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {selectedChannel ? (
                  <Button
                    className="w7 sevenly-btn text-white "
                    onClick={() => setOpen(true)}
                  >
                    Add
                  </Button>
                ) : (
                  <></>
                )}
              </div>

              <MUIDataTable
                title={"Market"}
                data={markets}
                columns={columns}
                options={options}
              />
            </>
          )}
        </>
      ) : (
        <>
          <TextField
            label="Zentrumhub Token"
            variant="outlined"
            required
            fullWidth
            className="my-2"
            placeholder="Zentrumhub Token"
            name="Zentrumhub Token"
            onChange={(e) => setZhToken(e.target.value)}
          />
          <Button
            className="w7 sevenly-btn text-white "
            onClick={() => getChannels()}
          >
            Add
          </Button>
        </>
      )}

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={opendel?.status}
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>Delete market</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          Are you sure you want to delete the market?
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className="submit-button"
            variant="contained"
            onClick={deleteAffiliate}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default Market;
